import * as React from 'react';

import { StyledCard, Row, CourseStat } from './CoursePicker.styles';

import { courseScoreColor, courseScoreText} from '../../../common/services';

interface IProps {
  data?: any;
  selectedCourse?: string;
  onSelectCourse?: any;
  completedLessons?: any;
  isParent?: boolean;
  isSchool?: boolean;
  isTeacher?: boolean;
  history?: object;
  onExploreCourse?: any
}

class CoursePicker extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  public onExploreCourse = (id) => {
    const { data, selectedCourse, isParent, isSchool, isTeacher, onExploreCourse } = this.props;
    const  history: any = this.props;
    const path = isParent ? 'parents' : isTeacher ? 'teachers' : 'schools';
    console.log({ history });
    if(isTeacher) {
      onExploreCourse(`/${path}/datacentre/courses/${id}`);
    }else {
      
     onExploreCourse(`/${path}/datacentre/courses/${id}`);
    }

  }

  public renderStudentCoursePicker() {
    const { data, selectedCourse, onSelectCourse, completedLessons } = this.props;
    const { courses_taken: courses } = data;
    const bestTotalScore = completedLessons.reduce((sum, lesson) => sum += lesson.BestScore, 0);
    const averageScore = (bestTotalScore / completedLessons.length) || 0;

    return (
      <StyledCard>
        <Row className="single-col">
          <h3>Pick a course to view your performance</h3>
          <select
            className="custom-select"
            value={selectedCourse}
            onChange={onSelectCourse}
          >
            <option value="">--</option>
            {courses.map((course: any, index: number) => {
              return (
                <option key={course.id} value={index}>
                  {course.Title}
                </option>
              );
            })}
          </select>
        </Row>
        {selectedCourse
          ? (
            <Row>
              <CourseStat>
                <h3>Lessons Completed</h3>
                <p>{completedLessons.length}</p>
              </CourseStat>
              <CourseStat>
                <h3>Average Score</h3>
                <p>{averageScore.toFixed()}%</p>
              </CourseStat>
            </Row>
          ) : null}
      </StyledCard>
    );
  }

  public renderParentSchoolCoursePicker() {
    const { data, selectedCourse, onSelectCourse, completedLessons } = this.props;
    const { CoursesAvailable: courses } = data;
    const course = courses[Number(selectedCourse)];

    return (
      <StyledCard>
        <Row className="cols-1">
          <h3>Pick a course to view your learners’ performance</h3>
          <select
            className="custom-select"
            value={selectedCourse}
            onChange={onSelectCourse}
          >
            <option value="">--</option>
            {courses.map((c: any, index: number) => {
              return (
                <option key={c.id} value={index}>
                  {c.Name}
                </option>
              );
            })}
          </select>
        </Row>
        {selectedCourse
          ? (
            <React.Fragment>
              <Row className="cols-3">
                <CourseStat>
                  <h3>Lessons Completed</h3>
                  <p>{course.LessonsCompleted}</p>
                </CourseStat>
                <CourseStat>
                  <h3>Learners Enrolled</h3>
                  <p>{course.StudentsEnrolled.length}</p>
                </CourseStat>
                <CourseStat>
                  <h3>Average Score</h3>
                  <p>{course.AverageScore.toFixed()}%</p>
                </CourseStat>
              </Row>
              <Row className="cols-1">
                <button
                  className="button blue-button"
                  onClick={this.onExploreCourse.bind(this, course.id)}
                >
                  Explore this course
                </button>
              </Row>
            </React.Fragment>
          ) : null}
      </StyledCard>
    );
  }

  public renderTeacherCoursePicker() {
     const { data, selectedCourse, onSelectCourse, completedLessons } = this.props;
    const courses = data.available_courses;
    const course = courses[Number(selectedCourse)];

    return (
      <StyledCard>
        <Row className="cols-1">
          <h3>Pick a course to view your learners’ performance</h3>
          <select
            className="custom-select"
            value={selectedCourse}
            onChange={onSelectCourse}
          >
            <option value="">--</option>
            {courses.map((c: any, index: number) => {
              return (
                <option key={c.course_id} value={index}>
                  {c.course_display_name ? c.course_display_name : c.course_name}
                </option>
              );
            })}
          </select>
        </Row>
        {selectedCourse ? (
          <React.Fragment>
            <Row className="cols-3">
              <CourseStat>
                <h3>Lessons Completed</h3>
                <p>{course.lessons_completed}</p>
              </CourseStat>
              <CourseStat>
                <h3>Learners Enrolled</h3>
                <p>{course.total_students}</p>
              </CourseStat>
              <CourseStat>
                <h3>Average Progress</h3>
                <p
                  style={{
                    color: courseScoreColor(course.avg_score.toFixed()),
                    font: "normal normal 22px 'Roboto Condensed",
                    marginTop: ".5em",
                  }}
                >
                  {courseScoreText(course.avg_score.toFixed())}
                </p>
              </CourseStat>
            </Row>
            <Row className="cols-1">
              <button
                className="button blue-button"
                onClick={this.onExploreCourse.bind(this, course.course_id)}
              >
                Explore this course
              </button>
            </Row>
          </React.Fragment>
        ) : null}
      </StyledCard>
    );
  }

  public render() {
    const { isParent, isSchool, isTeacher } = this.props;

    if (isParent) { return this.renderParentSchoolCoursePicker() }
    if (isTeacher || isSchool) {return this.renderTeacherCoursePicker()}
    return this.renderStudentCoursePicker();
  }
}

export default CoursePicker;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CoursePicker/CoursePicker.tsx